<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" :ripple="false" icon>
        <v-icon small>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item @click="$emit('showUser', user.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-eye </v-icon>
        <span class="body-2">{{ $t('hausefulUsers.action.details') }}</span>
      </v-list-item>

      <v-list-item @click="$emit('updateUser', user.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-pencil </v-icon>
        <span class="body-2">{{ $t('hausefulUsers.action.edit') }}</span>
      </v-list-item>

      <v-list-item @click="$emit('impersonateUser', user.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-account-cowboy-hat </v-icon>
        <span class="body-2">{{$t('impersonate.action')}}</span>
      </v-list-item>

      <v-list-item v-if="!user.checklist_id" @click="$emit('createUserOnChecklist', user.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-link-variant </v-icon>
        <span class="body-2">{{$t('hausefulUsers.action.checklistLink')}}</span>
      </v-list-item>

      <v-list-item v-if="!user.deleted_at" @click="$emit('deleteUser', user.id)">
        <v-icon class="mr-3 grey--text text--lighten-1" small left> mdi-delete </v-icon>
        <span class="body-2">{{ $t('hausefulUsers.action.delete') }}</span>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'HausefulUsersListMenu',

  props: {
    user: {
      type: Object,
      required: true,
    }
  }
}
</script>
